function obtenerItems(resumen) {
  if (!resumen || !Array.isArray(resumen.preguntas)) return [];

  return resumen.preguntas.reduce((items, grupo) => {
    const respuestas = Array.isArray(grupo.respuestas) ? grupo.respuestas : [];
    return items.concat(respuestas.map((respuesta) => ({
      pregunta: grupo.pregunta,
      respuesta,
    })));
  }, []);
}

function calcularMedia(items) {
  const puntuaciones = items
    .map(({ respuesta }) => respuesta.puntuacion)
    .filter((puntuacion) => puntuacion !== null && puntuacion !== undefined)
    .map(Number);

  if (!puntuaciones.length) return null;

  const total = puntuaciones.reduce((suma, puntuacion) => suma + puntuacion, 0);
  return Math.round((total / puntuaciones.length) * 10) / 10;
}

function crearResumen(items, tipo, sujeto = null) {
  const gruposPreguntas = new Map();

  items.forEach(({ pregunta, respuesta }) => {
    const preguntaId = pregunta.id;
    if (!gruposPreguntas.has(preguntaId)) {
      gruposPreguntas.set(preguntaId, {
        pregunta,
        respuestas: [],
      });
    }
    gruposPreguntas.get(preguntaId).respuestas.push(respuesta);
  });

  const preguntas = Array.from(gruposPreguntas.values()).map((grupo) => {
    const itemsPregunta = grupo.respuestas.map((respuesta) => ({
      pregunta: grupo.pregunta,
      respuesta,
    }));
    const totalPuntuaciones = grupo.respuestas.filter(
      (respuesta) => respuesta.puntuacion !== null && respuesta.puntuacion !== undefined
    ).length;

    return {
      pregunta: grupo.pregunta,
      valoracion: calcularMedia(itemsPregunta),
      total_respuestas: grupo.respuestas.length,
      total_puntuaciones: totalPuntuaciones,
      respuestas: grupo.respuestas,
    };
  }).sort((a, b) => {
    const ordenA = Number(a.pregunta.orden || 0);
    const ordenB = Number(b.pregunta.orden || 0);
    return ordenA - ordenB || Number(a.pregunta.id) - Number(b.pregunta.id);
  });

  return {
    tipo,
    sujeto,
    valoracion: calcularMedia(items),
    total_valoraciones: new Set(items.map(({ respuesta }) => respuesta.valoracion_id)).size,
    total_respuestas: items.length,
    preguntas,
  };
}

export function filtrarResumenPorTipo(resumen, tipo) {
  const items = obtenerItems(resumen).filter(({ respuesta }) => respuesta.tipo === tipo);
  return crearResumen(items, tipo);
}

export function agruparResumenPorProveedor(resumen) {
  const grupos = new Map();

  obtenerItems(resumen).forEach((item) => {
    const proveedor = item.respuesta.proveedor;
    if (!proveedor || proveedor.id === null || proveedor.id === undefined) return;

    if (!grupos.has(proveedor.id)) {
      grupos.set(proveedor.id, {
        proveedor,
        items: [],
      });
    }
    grupos.get(proveedor.id).items.push(item);
  });

  return Array.from(grupos.values())
    .map((grupo) => ({
      proveedor: grupo.proveedor,
      resumen: crearResumen(grupo.items, resumen.tipo, grupo.proveedor),
    }))
    .sort((a, b) => nombreProveedor(a.proveedor).localeCompare(nombreProveedor(b.proveedor), "es"));
}

export function nombreProveedor(proveedor) {
  if (!proveedor) return "Rutas Meigas";
  return proveedor.nombre_alias || proveedor.nombre || `Proveedor #${proveedor.id}`;
}
